module.exports = __webpack_public_path__ + "img/hnt.2d6e2a01.svg";